(() => {
  function setup() {
    const home = document.body;
    if (!home || home.dataset.ready) return;
    home.dataset.ready = 'true';
    const nav = document.querySelector('.header__inline-menu');
    let queued = false;
    const update = () => {
      queued = false;
      if (!home.isConnected) return;
      const announcement = document.querySelector('.announcement-bar-section');
      document.body.style.setProperty('--tac-header-top', `${Math.max(0, announcement?.getBoundingClientRect().bottom || 0)}px`);
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    nav?.addEventListener('focusout', schedule);
    update();
    nav?.querySelectorAll('header-menu > details').forEach(details => {
      const summary = details.querySelector('summary');
      let openedByHover = false;
      const desktopHover = () => matchMedia('(min-width: 990px) and (hover: hover)').matches;
      const close = () => { details.open = false; summary.setAttribute('aria-expanded', 'false'); };
      details.addEventListener('pointerenter', () => {
        if (!desktopHover()) return;
        openedByHover = !details.open;
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      });
      summary.addEventListener('click', event => {
        if (event.detail && openedByHover) { event.preventDefault(); openedByHover = false; }
      });
      details.addEventListener('pointerleave', () => {
        openedByHover = false;
        if (desktopHover() && !details.contains(document.activeElement)) close();
      });
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close(); summary.focus(); }
      });
      details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
    });
    const grid = home.querySelector('[data-tac-products]');
    if (!grid) return;
    const cards = Array.from(grid.children);
    const ids = cards.map(card => card.dataset.productId);
    const key = `tac-featured-v1:${ids.join(',')}`;
    try {
      let order = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!Array.isArray(order) || order.length !== ids.length || new Set(order).size !== ids.length || order.some(id => !ids.includes(id))) {
        order = [...ids];
        for (let i = order.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [order[i], order[j]] = [order[j], order[i]];
        }
        sessionStorage.setItem(key, JSON.stringify(order));
      }
      order.forEach(id => grid.appendChild(cards.find(card => card.dataset.productId === id)));
    } catch {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();


(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 749px)');
  const states = new Map();
  const saveData = () => Boolean(navigator.connection && navigator.connection.saveData);
  const permitted = state => !reduced.matches && !saveData() && !state.userPaused && !state.blocked && !state.failed && state.visible && !document.hidden;
  function label(state) {
    const key = state.blocked ? 'playLabel' : state.userPaused ? 'resumeLabel' : 'pauseLabel';
    state.button.setAttribute('aria-label', state.button.dataset[key]);
    state.button.setAttribute('title', state.button.dataset[key]);
    state.button.dataset.tacVideoState = state.blocked || state.userPaused ? 'play' : 'pause';
    state.button.hidden = reduced.matches || saveData() || state.failed || (!state.ready && !state.blocked);
  }
  function stop(state, showPoster) {
    state.epoch += 1;
    state.pending = false;
    state.video.pause();
    if (showPoster) {
      state.ready = false;
      state.media.classList.remove('tac-hero__video-ready');
    }
    label(state);
  }
  function update(state) {
    if (!permitted(state)) {
      stop(state, reduced.matches || saveData() || state.blocked || state.failed);
      return;
    }
    const source = mobile.matches ? state.media.dataset.mobileSrc : state.media.dataset.desktopSrc;
    if (!source) { state.failed = true; stop(state, true); return; }
    if (state.source !== source) {
      stop(state, true);
      state.source = source;
      state.video.src = source;
      state.video.poster = mobile.matches ? state.media.dataset.mobilePoster : state.media.dataset.desktopPoster;
      state.video.load();
    }
    if (state.pending || !state.video.paused) { label(state); return; }
    state.pending = true;
    const epoch = ++state.epoch;
    let promise;
    try { promise = state.video.play(); }
    catch { state.blocked = true; stop(state, true); return; }
    if (promise && typeof promise.then === 'function') {
      promise.then(() => {
        if (epoch !== state.epoch) return;
        state.pending = false;
        if (!permitted(state)) stop(state, reduced.matches || saveData());
      }).catch(() => {
        if (epoch !== state.epoch) return;
        state.pending = false;
        state.blocked = true;
        stop(state, true);
      });
    } else { state.pending = false; }
  }
  function setup(root = document) {
    root.querySelectorAll('[data-tac-video-background]').forEach(media => {
      if (states.has(media)) return;
      const video = media.querySelector('video');
      const hero = media.closest('[data-tac-hero]');
      const button = hero && hero.querySelector('[data-tac-video-toggle]');
      if (!video || !button) return;
      const state = { media, video, button, userPaused: false, blocked: false, failed: false, ready: false, pending: false, visible: !('IntersectionObserver' in window), epoch: 0, source: '', observer: null };
      states.set(media, state);
      video.muted = true;
      video.defaultMuted = true;
      button.addEventListener('click', () => {
        if (state.blocked) { state.blocked = false; state.userPaused = false; }
        else state.userPaused = !state.userPaused;
        update(state);
      });
      video.addEventListener('playing', () => {
        if (!permitted(state)) { stop(state, reduced.matches || saveData()); return; }
        state.ready = true;
        state.pending = false;
        media.classList.add('tac-hero__video-ready');
        label(state);
      });
      video.addEventListener('error', () => { state.failed = true; stop(state, true); });
      if ('IntersectionObserver' in window) {
        state.observer = new IntersectionObserver(entries => {
          state.visible = entries.some(entry => entry.isIntersecting);
          update(state);
        }, { threshold: 0 });
        state.observer.observe(hero);
      }
      update(state);
    });
  }
  const updateAll = () => states.forEach(update);
  [reduced, mobile].forEach(query => {
    if (query.addEventListener) query.addEventListener('change', updateAll);
    else query.addListener(updateAll);
  });
  if (navigator.connection && navigator.connection.addEventListener) navigator.connection.addEventListener('change', updateAll);
  document.addEventListener('visibilitychange', updateAll);
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, media) => {
      if (!event.target.contains(media)) return;
      stop(state, true);
      if (state.observer) state.observer.disconnect();
      states.delete(media);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
})();
